import React, { useEffect, useMemo, useState } from "react";
import { StyledTablePage } from "../../styled-components/StyledTablePage.style";
import Flex from '@react-css/flex';
import Modal from 'react-modal';
import { StyledForm } from "../../styled-components/StyledForm.style";
import api from '../../services/api';

export const ModalNotafiscalHistorico = ({ idTimesheet, isOpen, onAfterOpen, onRequestClose }) => {
    const [historicos, setHistoricos] = useState([]);
    const config = {
        headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Credentials': false
        }
    }

    const style = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            borderRadius: "0px",
            minWidth: '35%',
            overflowY: 'auto',
            minHeight: '45%',
            maxHeight: '90%',
            maxWidth: '100%'
        },
        overlay: {
            zIndex: 9999
        }
    };

    const colunas = useMemo(() => [{
        columns: [
            {
                Header: "Nº Nota Fiscal"
            },
            {
                Header: "Status"
            },
            {
                Header: "Faturado em"
            },
            {
                Header: "Recebido em"
            },
            {
                Header: "Reemitida em"
            },
            {
                Header: "Cancelada em"
            },
            {
                Header: "Executado por"
            },
            {
                Header: "Valor Liq. Recebido"
            },
            // {
            //     Header: "Valor Impostos"
            // },
            {
                Header: "Valor Total"
            }]
    }],
        []);

    useEffect(() => {
        const asyncFn = async () => {
            setHistoricos([])
            if (idTimesheet) {
                try {
                    const response = await api.get(`notafiscal/${idTimesheet}/historico`, config);
                    setHistoricos(response.data.data);
                } catch (err) { }
            }
        }
        asyncFn();
    }, [idTimesheet])

    return (
        <Modal
            isOpen={isOpen}
            onAfterOpen={onAfterOpen}
            onRequestClose={onRequestClose}
            contentLabel="Histórico"
            style={style}
            ariaHideApp={false}
            shouldCloseOnOverlayClick={false}
        >
            <StyledForm>
                <p className="modal-close" onClick={onRequestClose}>X</p>
            </StyledForm>
            <Flex>
                <StyledForm style={{ width: "100%" }}>
                    <Flex>
                        <Flex.Item className="modal-width">
                            <div className="position-relative form-group">
                                <p className="modal-title">Histórico Nota Fiscal</p>
                            </div>
                        </Flex.Item>
                    </Flex>
                    <StyledTablePage>
                        <div className="table-scroll">
                            <table className="table table-bordered table-width">
                                <thead>
                                    <tr className="table-legend-info">
                                        {colunas[0].columns.map(column => (
                                            <th key={column.Header}>{column.Header}</th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {historicos?.map((historico, index) => (
                                        <tr key={historico.idNotaFiscalItemAtividadeLog} className={`${index == 0 ? 'primeiro-ativo' : ''}`}>
                                            <td className="text-center">{historico.numero}</td>
                                            <td className="text-center">{historico.status}</td>
                                            <td className="text-center">{historico.dataNotaFiscal}</td>
                                            <td className="text-center">{historico.dataRecebimento}</td>
                                            <td className="text-center">{historico.dataReemissao}</td>
                                            <td className="text-center">{historico.dataCancelamento}</td>
                                            <td className="text-center">{historico.usuario}</td>
                                            <td className="text-center">{historico.valorTotalRecebido}</td>
                                            <td className="text-center">{historico.valorTotal}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </StyledTablePage>
                </StyledForm>
            </Flex>
        </Modal>
    );
};